import { endOfMonth, startOfMonth } from 'date-fns';

/**
 * Диапазон дат, с которым открывается приложение.
 *
 * Раньше здесь стояла развилка по тенанту: для mesoreal и electrobike диапазон был прибит
 * гвоздями к 01.01.2024 — 31.07.2026, чтобы демо-стенд сразу показывал засеянную историю.
 * На живом стенде это выглядит как поломка: сегодняшние звонки не попадают в диапазон,
 * дашборд пуст, и причину видно только в исходниках. Дата конца к тому же протухла —
 * с августа 2026 окно не покрывает даже текущий месяц.
 *
 * Поэтому дефолт один для всех и вычисляется от текущей даты. Нужен другой период —
 * он выбирается в UI; подпирать это именем тенанта в коде больше не будем.
 */
export const getDefaultDateRange = (now = new Date()) => ({
  from: startOfMonth(now),
  to: endOfMonth(now)
});

export default getDefaultDateRange;
